<template>
    <w-dialog
        :model-value="show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white"
    >
    <z-page title="Semak Hak Milik" :append-button="true">
        <w-form @success="onSemak">
            <w-flex class="mt3" >
                <div class="xs2">
                    <w-radio
                        class="mr2"
                        v-model="form.form_option"
                        name="radio"
                        return-value="option1"
                    >
                        Barcode / No. Akaun
                    </w-radio>
                </div>
                <div class="xs10 mr3">
                    <w-input
                        v-model="form.barcode"
                        placeholder="Sila Masukkan Barcode"
                        :disabled="form.form_option !== 'option1'"
                        :validators="[validators.required]"
                        maxlength="30"
                    ></w-input>
                </div>
            </w-flex>
             <w-flex class="px6" v-if="$zutil.can('Kemaskini Hakmilik')">
                <div class="spacer" />
                <w-button
                    :loading="loading"
                    text
                    @click="show=false"
                >
                    Batal
                </w-button>
                <w-button :loading="loading" class="ml3" type="submit"> Hantar </w-button>
            </w-flex>
        </w-form>
    </z-page>
    </w-dialog>
</template>

<script>
import WaveUI from "wave-ui";

export default {
    components:{

    },
    props:{
        show:Boolean,
        onSemak:Function,
        form: [Array,Object],
        searching:Boolean,
    },
    data(){
        return {
            waveui: new WaveUI(),
            valid :null,
            validators: {
               required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            apiBaseUrl : process.env.MIX_API_BASE_URL,
            loading:false,
            dialog :{
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                width: "50%",
            },
            error:null,
        }
    }
}
</script>
